import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';

export type CashbookVoidTarget = 'entry' | 'debt';

type Props = {
  open: boolean;
  target: CashbookVoidTarget | null;
  busy: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function CashbookVoidConfirmDialog({ open, target, busy, onClose, onConfirm }: Props) {
  const { t } = useTranslation();

  if (!open || !target) return null;

  const title =
    target === 'debt' ? t('cashbook.debts.voidTitle') : t('cashbook.voidTitle');
  const message =
    target === 'debt' ? t('cashbook.debts.voidConfirm') : t('cashbook.voidConfirm');

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cashbook-void-title"
    >
      <Card className="w-full max-w-md p-6 shadow-lg">
        <h2 id="cashbook-void-title" className="text-lg font-semibold">
          {title}
        </h2>
        <p className="mt-2 text-sm text-[var(--fv-text-muted)]">{message}</p>
        <div className="mt-6 flex justify-end gap-2">
          <Button variant="secondary" onClick={onClose} disabled={busy}>
            {t('common.cancel')}
          </Button>
          <Button variant="dangerSoft" loading={busy} onClick={onConfirm}>
            {t('cashbook.voidConfirmButton')}
          </Button>
        </div>
      </Card>
    </div>
  );
}
